import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { HeaderV2Component } from './header-v2.component';
 
@NgModule({
  declarations: [
    HeaderV2Component,
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    HeaderV2Component,
  ],
})
export class HeaderV2Module { }
 